import { memo } from 'react';
import { createPortal } from 'react-dom';

import NavMenuBack from './NavMenuBack/NavMenuBack';
import NavMenuLinks from './NavMenuLinks/NavMenuLinks';

const NavMenu = () => {
  const container = document.body;
  if (!container) {
    return null;
  }

  return createPortal(
    <>
      <NavMenuBack />
      <NavMenuLinks />
    </>,
    container,
  );
};

export default memo(NavMenu);
